import { type IHotel, RenovationType } from '@entities/hotel';

function filterHotelByRenovation(hotel: IHotel, renovations: RenovationType[]): boolean {
    if(!renovations.length) return true;

    if(!hotel.renovationTypes.length) return false;

    return hotel.renovationTypes.some((type) => renovations.includes(type));
}

export default filterHotelByRenovation;
